import { Component, OnInit } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { MyAccountService } from "../my-account.service";
import { environment } from "../../../environments/environment";
@Component({
  selector: "app-purchase-history",
  templateUrl: "./purchase-history.component.html",
  styleUrls: ["./purchase-history.component.css"],
})
export class PurchaseHistoryComponent implements OnInit {
  purchaseData: any = [];
  app_constant: any;
  isDragging: boolean;
  constructor(public myAccountService: MyAccountService) {}

  ngOnInit(): void {
    this.getPurchaseHistory();
    this.app_constant = environment;
  }

  toprated: OwlOptions = {
    loop: false,
    autoplay: false,
    mouseDrag: true,
    autoWidth: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    smartSpeed: 1,
    skip_validateItems: true,
    navText: ["", ""],
    responsive: {
      0: {
        items: 1.3,
      },
      380: {
        items: 1.3,
      },
      450: {
        items: 2.1,
      },
      650: {
        items: 3.1,
      },
      910: {
        items: 3.1,
      },
      1108: {
        items: 4.1,
      },
      1230: {
        items: 4.1,
      },
      1257: {
        items: 4.1,
      },
    },
    nav: true,
  };

  getPurchaseHistory() {
    this.myAccountService.purchaseHistory().subscribe(
      (data: any) => {
        this.purchaseData = data.results;
      },
      (err) => {
        if (err) {
          setTimeout(() => {}, 3000);
        }
      }
    );
  }
}
